// TODO This just needs done - follow similar approach as the other details pages, this does allow for extra features though
import React, { useState, useEffect } from "react";
import {
    Layout,
    Row,
    Col,
    Form,
    Input,
    Button,
    notification,
    Alert,
    Card,
    Drawer,
} from "antd";
import User from "../../../../enums/User";
import useQuery from "../../../../hooks/useQuery";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import AddToCalendar from "react-add-to-calendar";
import * as WetwheelsApi from "../../../../client-swagger/api";
import { useApp } from "../../../../AppContext";
import ManifestPassengerList from "../Common/ManifestPassengerList";
import ICalendarEventDetails from "../../../../interfaces/ICalendarEventDetails";
import HandleBookingDecision from "../Skipper/HandleBookingDecision";
import SkipperOrCrewAudit from "../Common/SkipperOrCrewAudit";
import BookingSummary from "../../../../components/Booking/BookingSummary";
import CombinedBookingSummary from "../Common/CombinedBookingSummary";
import ClientDetails from "../Common/ClientDetails";
import BookingDetails from "../Common/BookingDetails";
import AddChildBooking from "./ChildBooking/AddChildBooking";

const base =
    "data:image/png;base64,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";

const DashboardBookingsDetail = () => {
    const {
        authHeaderOptions,
        notifyError,
        notifySuccess,
        userType,
        showAccept,
        setShowAccept,
        createAddToCalEvent,
    } = useApp();

    const [, setIsLoading] = useState<boolean>(false);
    const [bookingData, setBookingData] = useState(null);
    const [skippers, setSkippers] = useState<Array<any>>(null);
    const [crew, setCrew] = useState<Array<any>>(null);
    const [mainBookingId, setMainBookingId] = useState<string>("");

    const [drawerAddVisible, setDrawerAddVisible] = useState<boolean>(false);
    const query = useQuery();

    const [numberPax, setNumberPax] = useState<number>(0);
    const [numberWheelchairs, setNumberWheelchairs] = useState<number>(0);
    const [numberDisabled, setNumberDisabled] = useState<number>(0);

    const [form] = Form.useForm();

    let { id } = useParams() as any;

    useEffect(() => {
        const img: any = document.getElementById("signature");
        if (img) {
            img.src = base;
        }
    }, []);

    const handleResendConfirmationEmails = () => {
        notification.success({
            message: "success",
            description: "Confirmation email send",
        });
    };

    const saveSkipper = async () => {
        const skipperId = form.getFieldValue("SkipperId");

        if (skipperId === "none") {
            const { success, message }: WetwheelsApi.ApiResponse =
                await new WetwheelsApi.BookingApi().skipperRemove(
                    id,
                    authHeaderOptions,
                );
            if (!success) {
                notifyError(message);
                return;
            }
            notifySuccess("Skipper updated. Only admin emails have been sent");
            await fetchBookingData(id);
        } else {
            const { success, message }: WetwheelsApi.ApiResponse =
                await new WetwheelsApi.BookingApi().skipperAcceptBooking(
                    {
                        bookingId: id,
                        skipperId,
                        status: "Confirmed",
                    },
                    authHeaderOptions,
                );
            if (!success) {
                notifyError(message);
                return;
            }
            notifySuccess("Skipper updated. Only admin emails have been sent");
            await fetchBookingData(id);
        }
    };

    const saveCrew = async () => {
        const crewId = form.getFieldValue("CrewId");
        console.log("crew id", crewId);

        if (crewId === "none") {
            const { success, message }: WetwheelsApi.ApiResponse =
                await new WetwheelsApi.BookingApi().crewRemove(
                    id,
                    authHeaderOptions,
                );
            if (!success) {
                notifyError(message);
                return;
            }
            notifySuccess("Crew updated. Only admin emails have been sent");
            await fetchBookingData(id);
        } else {
            const { success, message }: WetwheelsApi.ApiResponse =
                await new WetwheelsApi.BookingApi().crewAcceptBooking(
                    {
                        bookingId: id,
                        crewId,
                        status: "Confirmed",
                    },
                    authHeaderOptions,
                );
            if (!success) {
                notifyError(message);
                return;
            }
            notifySuccess("Crew updated. Only admin emails have been sent");
            await fetchBookingData(id);
        }
    };

    const handleCsvDownload = async () => {
        const { message, success, data } =
            await new WetwheelsApi.ManifestApi().manifestExportBookingIdGet(
                id,
                authHeaderOptions,
            );

        if (success) {
            downloadCsv(data, message);
        }
    };

    const downloadCsv = (csv: string, fileName: string) => {
        const linkSource = `data:text/csv;base64,${csv}`;
        const downloadLink = document.createElement("a");

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleCancelBooking = async () => {
        let cancelAlertMsg =
            "Are you sure you want to cancel this booking? The client will be sent a cancel notification.";

        if (bookingData.isParentBooking && bookingData.subBookings.length) {
            cancelAlertMsg =
                "Are you sure you want to cancel this booking? The client will be sent a cancel notification. NOTE: This will ONLY cancel the main booking. The next Subbooking will be made the Main booking.";
        }

        if (window.confirm(cancelAlertMsg)) {
            const { success, message }: WetwheelsApi.ApiResponse =
                await new WetwheelsApi.BookingApi().cancelBooking(
                    {
                        bookingId: id,
                    },
                    authHeaderOptions,
                );
            if (!success) {
                notifyError(message);
                return;
            }
            notifySuccess("The booking has been cancelled");
            setIsLoading(false);
            await fetchBookingData(id);
        }
    };

    const fetchBookingData = async (bookingId: string) => {
        setIsLoading(true);

        const { success, data, message }: WetwheelsApi.ApiResponse =
            await new WetwheelsApi.BookingApi().booking(
                bookingId,
                authHeaderOptions,
            );
        setIsLoading(false);
        if (!success) {
            notifyError(message);
            return;
        }
        console.log("bookingData", data);

        setBookingData(data);
        setMainBookingId(data.isChildBooking ? data.parentBookingId : data.id);

        setNumberPax(data.numberOfPassengers);
        setNumberWheelchairs(data.numberOfWheelchairs);
        setNumberDisabled(data.numberOfDisabledNonWheelchair);
    };

    const fetchAllSkippers = async () => {
        const { success, data, message }: WetwheelsApi.ApiResponse =
            await new WetwheelsApi.SkipperApi().skippersGet(authHeaderOptions);
        setIsLoading(false);
        if (!success) {
            notifyError(message);
            return;
        }
        setSkippers(data);
    };

    const fetchAllCrew = async () => {
        const { success, data, message }: WetwheelsApi.ApiResponse =
            await new WetwheelsApi.CrewApi().getAllCrew(authHeaderOptions);
        setIsLoading(false);
        if (!success) {
            notifyError(message);
            return;
        }
        setCrew(data);
    };

    useEffect(() => {
        console.log(id);
        // fetch data
        fetchBookingData(id);
        setShowAccept(true);
        if (userType === User.Admin) {
            fetchAllCrew();
            fetchAllSkippers();
        }
        form.resetFields();
    }, [id]);

    const onClose = () => {
        setDrawerAddVisible(false);
        fetchBookingData(id);
    };

    const updatePax = async () => {
        const { code, data, message, success } =
            await new WetwheelsApi.BookingApi().updateBooking(
                {
                    numberOfPassengers: numberPax,
                    numberOfNonWheelchairDisabled: numberDisabled,
                    numberOfWheelchairs: numberWheelchairs,
                },
                bookingData.id,
                authHeaderOptions,
            );

        console.log(message);
        console.log(success);
        if (!success) {
            notifyError(message);
            return;
        } else {
            notifySuccess("Passenger numbers successfully updated");
            await fetchBookingData(id);
        }
    };

    const isParentOrChild =
        bookingData &&
        (bookingData.isParentBooking || bookingData.isChildBooking);

    const handleMarkBookingAsComplete = async () => {
        const { code, data, message, success } =
            await new WetwheelsApi.BookingApi().completeBooking(
                { bookingId: bookingData.id },
                authHeaderOptions,
            );

        if (!success) {
            notifyError(message);
            return;
        } else {
            notifySuccess("Booking completed manually");
            await fetchBookingData(id);
        }
    };

    return bookingData ? (
        <>
            <Layout style={{ backgroundColor: "white", padding: 30 }}>
                <Layout.Header
                    className="mb-m"
                    style={{ padding: 0, background: "none", width: "100%" }}
                >
                    <>
                        {bookingData.isChildBooking && (
                            <>
                                <h3>
                                    Sub-booking{" "}
                                    {bookingData && bookingData.uniqueKey}&nbsp;
                                    <a
                                        style={{ fontSize: "20px" }}
                                        href={`/dashboard/bookings/${bookingData.parentBooking.id}`}
                                    >
                                        - view main booking{" "}
                                        {bookingData.parentBooking.uniqueKey}
                                    </a>
                                </h3>
                            </>
                        )}
                        {bookingData.isParentBooking && (
                            <>
                                <h3>
                                    Main Booking{" "}
                                    {bookingData && bookingData.uniqueKey}
                                </h3>
                            </>
                        )}
                        {!bookingData.isParentBooking &&
                            !bookingData.isChildBooking && (
                                <h3>
                                    Booking{" "}
                                    {bookingData && bookingData.uniqueKey}
                                </h3>
                            )}
                    </>
                </Layout.Header>

                <Layout.Content>
                    {bookingData?.status !== "Complete" &&
                        bookingData?.status !== "Cancelled" &&
                        bookingData?.status !== "ConfirmedAndComplete" && (
                            <Row
                                justify="space-between"
                                className="mb-m"
                                gutter={16}
                            >
                                <Col xs={24} md={24} lg={24}>
                                    <Alert
                                        type="warning"
                                        message={
                                            <>
                                                <p>
                                                    This booking still has
                                                    availability
                                                </p>

                                                <Button
                                                    type="primary"
                                                    onClick={() =>
                                                        handleMarkBookingAsComplete()
                                                    }
                                                >
                                                    Mark booking as complete
                                                </Button>
                                            </>
                                        }
                                    ></Alert>
                                </Col>
                            </Row>
                        )}

                    <Row justify="space-between" className="mb-m" gutter={16}>
                        <Col xs={24} md={24} lg={isParentOrChild ? 12 : 24}>
                            {isParentOrChild && (
                                <CombinedBookingSummary
                                    summary={bookingData.combinedBookingSummary}
                                    mainBookingId={mainBookingId}
                                    contactSummary={
                                        bookingData.combinedContactDetails
                                    }
                                ></CombinedBookingSummary>
                            )}
                        </Col>
                        <Col xs={24} md={18} lg={12}>
                            {bookingData.isChildBooking ? (
                                <>
                                    <Alert
                                        type="info"
                                        message={
                                            <>
                                                This is a sub-booking of{" "}
                                                <button className="a-button v-button-secondary my-xs">
                                                    <a
                                                        style={{
                                                            fontSize: "20px",
                                                            color: "#000",
                                                        }}
                                                        href={`/dashboard/bookings/${bookingData.parentBooking.id}`}
                                                    >
                                                        {
                                                            bookingData
                                                                .parentBooking
                                                                .uniqueKey
                                                        }
                                                    </a>
                                                </button>
                                            </>
                                        }
                                        description="Actions will be limited. Assigning crew and skipper can be performed from the main booking"
                                    ></Alert>
                                </>
                            ) : null}

                            {bookingData.isParentBooking ? (
                                <>
                                    <Alert
                                        type="info"
                                        message={
                                            <div className="mb-s">
                                                <p>
                                                    {bookingData.isParentBooking
                                                        ? "This is a main booking, with sub-bookings"
                                                        : "You can add a sub-booking if you wish"}
                                                </p>
                                            </div>
                                        }
                                        description={
                                            <>
                                                {bookingData.subBookings &&
                                                    bookingData.subBookings.map(
                                                        (c: any) => (
                                                            <div
                                                                className="mb-s"
                                                                key={c.id}
                                                            >
                                                                {" "}
                                                                <a
                                                                    key={c.id}
                                                                    style={{
                                                                        fontSize:
                                                                            "20px",
                                                                        color: "#000",
                                                                    }}
                                                                    href={`/dashboard/bookings/${c.id}`}
                                                                >
                                                                    <button className="a-button v-button-secondary my-xs">
                                                                        {
                                                                            c.uniqueKey
                                                                        }
                                                                    </button>
                                                                    <div
                                                                        style={{
                                                                            marginLeft:
                                                                                "20px",
                                                                            fontSize:
                                                                                "14px",
                                                                        }}
                                                                    >
                                                                        PAX:{" "}
                                                                        {
                                                                            c.numberOfPassengers
                                                                        }
                                                                        {"  "}
                                                                        WC:{" "}
                                                                        {
                                                                            c.numberOfWheelchairs
                                                                        }
                                                                        {"  "}
                                                                        DIS:{" "}
                                                                        {
                                                                            c.numberOfDisabledNonWheelchair
                                                                        }
                                                                        {"  "}
                                                                        <br />
                                                                        Created:{" "}
                                                                        {moment(
                                                                            c.createdDate,
                                                                        ).format(
                                                                            "MMMM Do YYYY, HH:mm",
                                                                        )}
                                                                    </div>
                                                                </a>
                                                                <br />
                                                            </div>
                                                        ),
                                                    )}
                                            </>
                                        }
                                        action={
                                            <>
                                                {bookingData.status !==
                                                    "Cancelled" && (
                                                    <Button
                                                        type="primary"
                                                        onClick={() =>
                                                            setDrawerAddVisible(
                                                                true,
                                                            )
                                                        }
                                                    >
                                                        Add sub-booking
                                                    </Button>
                                                )}
                                            </>
                                        }
                                    ></Alert>
                                </>
                            ) : null}
                            {!bookingData.isChildBooking &&
                                !bookingData.isParentBooking && (
                                    <>
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                setDrawerAddVisible(true)
                                            }
                                        >
                                            Add sub-booking
                                        </Button>
                                    </>
                                )}
                        </Col>
                    </Row>
                </Layout.Content>

                <Layout.Content>
                    <Row gutter={[16, 16]}>
                        {bookingData.cancelledDate && (
                            <Col md={{ span: 24 }}>
                                <Alert
                                    type="error"
                                    message={`The booking was cancelled ${moment(
                                        bookingData.cancelledDate,
                                    ).calendar()} (${moment(
                                        bookingData.cancelledDate,
                                    ).format("MMMM Do YYYY, h:mm:ss a")})`}
                                />
                            </Col>
                        )}
                        <Col md={{ span: 24 }}>
                            <Form
                                labelCol={{
                                    xs: { span: 24 },
                                    md: { span: 6 },
                                    lg: { span: 6 },
                                }}
                                wrapperCol={{
                                    xs: { span: 24 },
                                    md: { span: 18 },
                                    lg: { span: 18 },
                                }}
                                layout="horizontal"
                                form={form}
                                name="mainForm"
                            >
                                <Row
                                    justify="space-between"
                                    className="mb-m"
                                    gutter={16}
                                >
                                    <Col lg={{ span: 12 }} md={{ span: 24 }}>
                                        <BookingDetails
                                            bookingData={bookingData}
                                        ></BookingDetails>
                                    </Col>
                                    <Col lg={{ span: 12 }} md={{ span: 24 }}>
                                        <ClientDetails
                                            clientUser={bookingData.clientUser}
                                            userType={userType}
                                        ></ClientDetails>
                                    </Col>
                                </Row>

                                <div className="mb-m">
                                    <h4>Passengers, Skipper and Crew</h4>

                                    <Form.Item label="Status of trip">
                                        {bookingData.status ===
                                        "ConfirmedAndComplete" ? (
                                            <>
                                                <Alert
                                                    type="success"
                                                    message="Confirmed (skipper assigned), and Complete"
                                                />
                                            </>
                                        ) : bookingData.status ===
                                          "Confirmed" ? (
                                            <>
                                                <Alert
                                                    type="success"
                                                    message="Confirmed - skipper assigned"
                                                />
                                            </>
                                        ) : bookingData.status ===
                                          "Unconfirmed" ? (
                                            <>
                                                <Alert
                                                    type="warning"
                                                    message="Not confirmed - no skipper assigned"
                                                />
                                            </>
                                        ) : bookingData.status === "Partial" ? (
                                            <>
                                                <Alert
                                                    type="warning"
                                                    message="Partial booking - not full"
                                                />
                                            </>
                                        ) : bookingData.status ===
                                          "Complete" ? (
                                            <>
                                                <Alert
                                                    type="info"
                                                    message="Complete booking"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <Alert
                                                    type="error"
                                                    message="Cancelled"
                                                />
                                            </>
                                        )}
                                    </Form.Item>

                                    <Form.Item label="No. of passengers">
                                        <Input
                                            defaultValue={
                                                bookingData.numberOfPassengers
                                            }
                                            onChange={(e) => {
                                                setNumberPax(
                                                    parseInt(e.target.value),
                                                );
                                            }}
                                            className="v-number"
                                        />
                                    </Form.Item>
                                    <Form.Item label="No. of wheelchair passenger">
                                        <Input
                                            defaultValue={
                                                bookingData.numberOfWheelchairs
                                            }
                                            onChange={(e) => {
                                                setNumberWheelchairs(
                                                    parseInt(e.target.value),
                                                );
                                            }}
                                            className="v-number"
                                        />

                                        <Button
                                            style={{ marginLeft: "100px" }}
                                            onClick={() => {
                                                console.log(numberPax);
                                                console.log(numberWheelchairs);
                                                console.log(numberDisabled);

                                                updatePax();
                                            }}
                                        >
                                            Update all pax numbers
                                        </Button>
                                    </Form.Item>
                                    <Form.Item
                                        style={{ wordWrap: "break-word" }}
                                        className=""
                                        label="No. of special needs passengers"
                                    >
                                        <Input
                                            defaultValue={
                                                bookingData.numberOfDisabledNonWheelchair
                                            }
                                            onChange={(e) => {
                                                setNumberDisabled(
                                                    parseInt(e.target.value),
                                                );
                                            }}
                                            className="v-number"
                                        />
                                    </Form.Item>

                                    {userType === User.Skipper ||
                                    userType == User.Crew ? (
                                        <>
                                            <Form.Item label="Skipper">
                                                {bookingData.skipper &&
                                                bookingData.skipper.user
                                                    ? bookingData.skipper.user
                                                          .firstName +
                                                      " " +
                                                      bookingData.skipper.user
                                                          .lastName +
                                                      " / " +
                                                      bookingData.skipper.user
                                                          .contactNumber +
                                                      " / " +
                                                      bookingData.skipper.user
                                                          .email
                                                    : "None"}
                                            </Form.Item>

                                            <Form.Item label="Crew">
                                                {bookingData.crew &&
                                                bookingData.crew.user
                                                    ? bookingData.crew.user
                                                          .firstName +
                                                      " " +
                                                      bookingData.crew.user
                                                          .lastName +
                                                      " / " +
                                                      bookingData.crew.user
                                                          .contactNumber +
                                                      " / " +
                                                      bookingData.crew.user
                                                          .email
                                                    : "None"}
                                            </Form.Item>
                                        </>
                                    ) : null}

                                    <hr />
                                    <Row gutter={24}>
                                        <Col xs={24} md={18} lg={12}>
                                            <Card type="inner">
                                                <SkipperOrCrewAudit
                                                    bookingData={bookingData}
                                                    skippersOrCrew={skippers}
                                                    fetchBookingData={
                                                        fetchBookingData
                                                    }
                                                    saveSkipperOrCrew={
                                                        saveSkipper
                                                    }
                                                    skipperOrCrew="Skipper"
                                                />
                                            </Card>
                                        </Col>
                                        <Col xs={24} md={18} lg={12}>
                                            <Card type="inner">
                                                <SkipperOrCrewAudit
                                                    bookingData={bookingData}
                                                    skippersOrCrew={crew}
                                                    fetchBookingData={
                                                        fetchBookingData
                                                    }
                                                    saveSkipperOrCrew={saveCrew}
                                                    skipperOrCrew="Crew"
                                                />
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="mb-m">
                                    <ManifestPassengerList
                                        bookingData={bookingData}
                                    />
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Layout.Content>
                <Layout.Footer
                    style={{ padding: 0, background: "none", width: "100%" }}
                >
                    <Row justify="space-around">
                        <Link to="/dashboard/bookings">
                            <button
                                style={{
                                    width: "250px",
                                }}
                                className="a-button v-button-primary m-s"
                            >
                                Back
                            </button>
                        </Link>
                        {/* <button
            className="a-button v-button-primary float-right"
            onClick={handleSaveForm}
            >
            Save
          </button> */}
                        {query.get("confirm") === "true" && (
                            <button
                                style={{
                                    width: "250px",
                                }}
                                className="a-button v-button-primary m-s"
                                onClick={handleResendConfirmationEmails}
                            >
                                Resend confirmation emails
                            </button>
                        )}

                        {bookingData.manifest &&
                            (userType === User.Admin ||
                                userType === User.Skipper) && (
                                <>
                                    <Link to={`/print/booking/${id}`}>
                                        <button
                                            style={{
                                                width: "250px",
                                            }}
                                            className="a-button v-button-primary m-s"
                                        >
                                            Export booking PDF
                                        </button>
                                    </Link>
                                    <button
                                        style={{
                                            width: "250px",
                                        }}
                                        onClick={handleCsvDownload}
                                        className="a-button v-button-primary m-s"
                                    >
                                        Export manifest CSV
                                    </button>
                                </>
                            )}

                        {bookingData.status !== "Cancelled" &&
                            userType === User.Admin && (
                                <button
                                    style={{
                                        width: "250px",
                                    }}
                                    className="a-button v-button-danger m-s"
                                    onClick={handleCancelBooking}
                                >
                                    {bookingData.isParentBooking &&
                                    bookingData.subBookings.length
                                        ? "Cancel main booking"
                                        : "Cancel booking"}
                                </button>
                            )}

                        {userType !== User.Admin && (
                            <button
                                style={{
                                    width: "250px",
                                }}
                                className="a-button v-button-primary m-s"
                            >
                                <AddToCalendar
                                    buttonLabel="Add to Calendar"
                                    event={createAddToCalEvent({
                                        contactNumber:
                                            bookingData.createdByUser
                                                .contactNumber,
                                        uniqueKey: bookingData.uniqueKey,
                                        firstName:
                                            bookingData.createdByUser.firstName,
                                        lastName:
                                            bookingData.createdByUser.lastName,
                                        email: bookingData.createdByUser.email,
                                        organisation: bookingData.organisation,
                                        startTime: bookingData.startDatetime,
                                        endTime: bookingData.endDatetime,
                                        eventType: bookingData.eventType.name,
                                        noOfPassengers:
                                            bookingData.numberOfPassengers,
                                        noOfWheelschairs:
                                            bookingData.numberOfWheelchairs,
                                        noOfNonWheelchairDisabled:
                                            bookingData.numberOfNonWheelchairDisabled,
                                        additionalInformation:
                                            bookingData.additionalInformation,
                                    } as ICalendarEventDetails)}
                                />
                            </button>
                        )}
                    </Row>
                </Layout.Footer>
            </Layout>
            <Drawer
                width={"40vw"}
                onClose={onClose}
                visible={drawerAddVisible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <AddChildBooking
                    closeWindow={onClose}
                    bookingId={bookingData.id}
                />
            </Drawer>
        </>
    ) : null;
};

export default DashboardBookingsDetail;
